import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams, useLocation } from 'react-router-dom';
import { useForm } from '../../hooks/useForm';
import backArrowIcon from '../../assets/img/back-arrow.png';
import "../../assets/css/common.css";
import { useAuth } from '../../routers/AuthProvider';
import axios from 'axios';
import { API_URL } from '../../utils/constant';
import { Toast } from '../../components/ToastComponent';


export default function EditUnitConversion() {
    const { id } = useParams();
    const location = useLocation();
    const { initialData } = location.state;
    const backPath = `/unit/conversion`;
    const { handleInputChange, formData, submitForm, setError, error } = useForm();
     useEffect(()=>{
                      if(error){
                         Toast.fire({
                  title: error ,
                  icon: "error",
                });
                      }
                  },[error])
    const navigate = useNavigate();
    const { user, setLoading } = useAuth();
     const [errorMessage, setErrorMessage] = useState("");
    const [baseQuantity, setBaseQuantity] = useState();

    const onSubmit = (e) => {
        e.preventDefault();
        setLoading(true)
        const data = {
            ...formData,
            status: 'ACTIVE',
        }
        submitForm('PUT', '/uoc/' + id, data, () => {
            navigate(backPath)
        },"Successfully Updated");
    }

    const [units, setUnits] = useState();
    useEffect(() => {
        axios.get(API_URL + '/unit', {
            withCredentials: true
        })
            .then(response => {
                setUnits(response.data.data)
            })
    }, [])

    return (
        <div className='sub-page-layout-1'>
            <Link className='back-to-page' to={backPath}>
                <img src={backArrowIcon} />
                Back
            </Link>
            <div className='container'>
                <h1 className='sub-page-title'>Edit Unit of Conversion</h1>
                <div className='form-container'>
                    <form onSubmit={onSubmit} className='form flex flex-col justify-between w-full'>
                        <div className='grid grid-cols-2 gap-9'>
                            <div className='grow'>
                                <label className='x-label input-required'>Base Unit</label>
                                <div className='dd-container'>
                                    <select
                                        type='text'
                                        required
                                        name='base_unit_id'
                                        value={formData.base_unit_id ? formData.base_unit_id : initialData.base_unit_id}
                                        onChange={handleInputChange}
                                        className='x-input dropdown'
                                    >
                                        {
                                            units && units.filter((item) => item.is_base_unit === true).map((item, index) => (
                                                <option key={index} value={item.unit_id}>{item.unit_name}</option>
                                            ))
                                        }
                                    </select>
                                </div>
                            </div>

                            <div className='grow'>
                                <label className='x-label input-required'>Base Quantity</label>
                                <input 
                                 //type="number"


  min={2}
                                type='text'
                                inputMode='numeric'
                                    required
                                    name='base_qty'
                                    defaultValue={initialData.base_qty}
                                    //onChange={handleInputChange}
                                    pattern="[2-9]{1,}"
                                     onKeyDown={e => {
    if (["e", "E", "+", "-"].includes(e.key)) {
      e.preventDefault();
    }
  }}
                                    onChange={e => {
                                        const numericValue = e.target.value.replace(/[^2-9]/g, "");
                                        setBaseQuantity(numericValue);

                                        const numeric = parseInt(numericValue, 10);

                                        if (!numericValue) {
                                            setErrorMessage("Number must be 2 or greater.");
                                        } else if (isNaN(numeric) || numeric < 2) {
                                            setErrorMessage("Number must be 2 or greater.");
                                        } else {
                                            setErrorMessage(""); // Clear message when valid
                                        }
                                        handleInputChange({ target: { name: 'base_qty', value: numericValue } });
                                    }}

                                    // onKeyDown={e => {
                                    //     if (e.key === "Enter") {
                                    //         e.preventDefault();
                                    //     }
                                    // }}
                                    className='x-input' />
                                    {errorMessage && (
                                    <div className="text-red-500 text-sm mt-1">{errorMessage}</div>
                                )}
                            </div>

                            <div className='grow'>
                                <label className='x-label input-required'>Converted Unit</label>
                                <div className='dd-container'>
                                    <select
                                        type='text'
                                        required
                                        name='converted_unit_id'
                                        value={formData.converted_unit_id ? formData.converted_unit_id : initialData.converted_unit_id}
                                        onChange={handleInputChange}
                                        className='x-input dropdown'
                                    >
                                        {
                                            // units && units.map((item, index) => (
                                            //     <option key={index} value={item.unit_id}>{item.unit_name}</option>
                                            // ))
                                            units && units
                                                .filter(unit => unit.is_base_unit === false)
                                                .map((unit) => (
                                                    <option key={unit.unit_id} value={unit.unit_id}>{unit.unit_name}</option>
                                                ))
                                        }
                                    </select>
                                </div>
                            </div>

                            <div className='grow'>
                                <label className='x-label input-required'>Converted Quantity</label>
                                <input type='number'
                                    readOnly
                                    required
                                    name='converted_qty'
                                    defaultValue={initialData.converted_qty}
                                    // onChange={handleInputChange}
                                    className='x-input' />
                            </div>

                            <div className='grow'>
                                <label className='x-label'>Remark</label>
                                <input type='text'
                                    name='remark'
                                    // autoComplete='false'
                                    defaultValue={initialData.remark}
                                    onChange={handleInputChange}
                                    className='x-input' />
                            </div>

                        </div>
                        <div className='form-btn-group'>
                           
                            <div className='flex justify-end gap-5 mt-5'>
                                <Link to={backPath} className='white-btn'>Cancel</Link>
                                <button type='submit' className='gold-btn'>Save</button>
                            </div>

                        </div>
                    </form>
                </div>

            </div>

        </div>
    )
}